<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
    >
      <div
        v-if="$route.query.play"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <b-button
          :disabled="currentId.prev_id === null"
          :variant="currentId.prev_id === null ? 'secondary' : 'primary'"
          @click="prevPage"
        >
          <feather-icon
            icon="ChevronLeftIcon"
          />
          Предыдущий
        </b-button>

        <b-button
          :disabled="currentId.next_id === null"
          :variant="currentId.next_id === null ? 'secondary' : 'primary'"
          @click="nextPage"
        >
          Следующий  <feather-icon icon="ChevronRightIcon" />
        </b-button>
      </div>

      <b-button
        v-show="!$route.query.play"
        class="mb-1 asasa"
        @click="$router.go(-1)"
      >
        <svg
          fill="currentColor"
          width="15"
          height="15"
          viewBox="0 0 24 24"
          class="material-design-icon__svg"
        >
          <path d="M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z" />
        </svg>
        Назад
      </b-button>

      <b-row>
        <b-col md="3">
          <verticalSide />
        </b-col>

        <b-col md="9">
          <topStatistics />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import verticalSide from './collectorDetail/verticalSide.vue'
import topStatistics from './collectorDetail/topStatistics.vue'

export default {
  beforeRouteUpdate(to, from, next) {
    this.SET_ACTIVETAB(false)
    const newId = to.params.id
    const params = {
      page: 1,
      page_size: 5,
      debt: newId,
    }
    this.FETCH_DK_DEBT_ID({
      id: newId,
    })
    this.historyTimeLine.results = []
    this.FETCH_HISTORY_TIMELINE(params)
    this.FETCH_PROMISE_LIST(params)
    this.FETCH_SK_HEADER_STA({ debt_id: newId })
    this.SET_ACTIVE(1)
    this.FETCH_REMINDER(newId)
    next()
  },
  components: {
    BRow,
    BCol,
    BButton,
    BOverlay,
    verticalSide,
    topStatistics,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('dk', ['currentId']),
    ...mapState('collectorDetail', ['historyTimeLine']),
  },
  mounted() {
    this.FETCH_DK_DEBT_ID({
      id: this.$route.params.id,
    })
    this.FETCH_CURRENT_ID({
      current_id: this.$route.params.id,
    })
    // old_id: this.currentId.prev_id,
  },
  methods: {
    ...mapActions('collectorDetail', ['FETCH_DK_DEBT_ID', 'FETCH_HISTORY_TIMELINE', 'FETCH_PROMISE_LIST', 'FETCH_SK_HEADER_STA', 'FETCH_REMINDER']),
    ...mapActions('dk', ['FETCH_CURRENT_ID']),
    ...mapMutations('collectorDetail', ['SET_ACTIVE', 'SET_CALL', 'SET_ACTIVETAB']),

    backToBack() {
      this.$router.go(-1)
    },

    prevPage() {
      this.loading = true
      this.FETCH_CURRENT_ID({
        current_id: this.currentId.prev_id,
        old_id: this.currentId.prev_id,
        action: 'prev',
      })
        .then(() => {
          this.SET_CALL(false)
          this.$router.push({
            name: 'collector-id',
            query: { play: 'true' },
            params: {
              id: this.currentId.current_id,
            },
          })
          this.loading = false
        })
        .catch(e => {
          if (e && e.message === 'Request failed with status code 403') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Нужно выполнить действие и заполнить комментарий',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            }, {
              position: 'bottom-right',
            })
            this.loading = false
          } else {
            this.$_errorToast(e)
            this.loading = false
          }
        })
    },

    nextPage() {
      this.loading = true
      this.FETCH_CURRENT_ID({
        current_id: this.currentId.next_id,
        old_id: this.currentId.current_id,
        action: 'next',
      })
        .then(() => {
          this.SET_CALL(false)
          this.$router.push({
            name: 'collector-id',
            query: { play: 'true' },
            params: {
              id: this.currentId.current_id,
            },
          })
          this.loading = false
        })
        .catch(e => {
          if (e && e.message === 'Request failed with status code 403') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Нужно выполнить действие и заполнить комментарий',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            }, {
              position: 'bottom-right',
            })
            this.loading = false
          } else {
            this.$_errorToast(e)
            this.loading = false
          }
        })
    },
  },
}
</script>
